import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios';

import { AuthTypeOption } from '../../account/git-credentials/types';

export interface UseHelmValuesPreviewOptions {
  repository: string;
  valuesFiles: string[];
  reference?: string;
  username?: string;
  password?: string;
  authorizationType?: AuthTypeOption;
  gitCredentialID?: number;
  tlsSkipVerify?: boolean;
  enabled?: boolean;
}

export function useHelmValuesPreview(options: UseHelmValuesPreviewOptions) {
  const {
    repository,
    valuesFiles,
    reference,
    username,
    password,
    authorizationType,
    gitCredentialID,
    tlsSkipVerify,
    enabled = true,
  } = options;

  return useQuery(
    [
      'helm-values-preview',
      repository,
      reference,
      valuesFiles,
      gitCredentialID,
    ],
    () =>
      getHelmValuesPreview({
        repository,
        valuesFiles,
        reference,
        username,
        password,
        authorizationType,
        gitCredentialID,
        tlsSkipVerify,
      }),
    {
      enabled:
        enabled &&
        !!repository &&
        Array.isArray(valuesFiles) &&
        valuesFiles.length > 0,
    }
  );
}

interface HelmValuesPreviewPayload {
  repository: string;
  valuesFiles: string[];
  reference?: string;
  username?: string;
  password?: string;
  authorizationType?: AuthTypeOption;
  gitCredentialID?: number;
  tlsSkipVerify?: boolean;
}

interface HelmValuesPreviewResponse {
  mergedValues: string;
  filesProcessed: string[];
  commitHash: string;
}

async function getHelmValuesPreview(
  payload: HelmValuesPreviewPayload
): Promise<HelmValuesPreviewResponse> {
  try {
    const { data } = await axios.post<HelmValuesPreviewResponse>(
      '/gitops/repo/helm/values',
      payload
    );
    return data;
  } catch (e) {
    throw parseAxiosError(
      e,
      'Unable to fetch and merge Helm values files from git'
    );
  }
}
